export default {"src":"/menu/_next/static/media/play.df3cb120.svg","height":485,"width":485,"blurWidth":0,"blurHeight":0};